import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    records: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    },
    editingProject: null,
    Nodesid: null,
    peopleList: [],
    ptoatl: 0
  },
  getters: {},
  mutations: {
    setpage(state, page) {
      state.pagination = page;
    },
    setRecords(state, payload) {
      state.records = payload.data;
      state.totalCount = payload.total;
    },
    setpeopleList(state, payload) {
      state.peopleList = payload.list;
      state.ptoatl = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    seeNodePeople(state, payload) {
      state.Nodesid = payload;
    }
  },
  actions: {
    getRecords({ commit }, query) {
      api.getRecords(query).then(({ data }) => {
        commit('setRecords', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    setNodes(content, data) {
      return api.setNode(data);
    },
    gettime(content, data) {
      return api.gettime(data);
    },
    settime(content, data) {
      return api.settime(data);
    },
    removeNode(content, data) {
      return api.removeNode(data);
    },
    changeNode(content, data) {
      return api.changeNode(data);
    },
    Newpeople({ commit }, data) {
      api.Nodepeople(data).then(({ data }) => {
        commit('setpeopleList', data);
      });
    },
    nodeList(content, data) {
      return api.nodeList(data);
    },
    setsort(content, data) {
      return api.setsort(data);
    }
  }
};

appStore.registerModule('setnode', store);
